export function topicsFunc() {
  let topicsArchivesList = $('.topicsArchivesList .archivesBtn');
  let topicsFlg = 0;
  topicsArchivesList.on('click', function () {
    $(this).stop().toggleClass('open');
    $(this).next().stop().slideToggle(500);
  });

  // topicsArchivesList.on({
  //'mouseover': function () {
  // topicsFlg = 1;
  //$(this).toggleClass('open');
  //$(this).next().stop().slideToggle(500);
  //}
  //});

  //マウスを乗せたら発動
  //  topicsArchivesList.hover(function () {
  //
  //    $(this).stop().toggleClass('open');
  //    $(this).next().stop().slideToggle(500);
  //
  //  });

  //マウスを乗せたら発動
  let responsibleCheck = $('#responsibleCheck').width();
  $('#topicsArchivesList').hover(function () {
    if (responsibleCheck == '1') {
      $(this).find('dd').stop().slideToggle()
      //ここにはマウスを離したときの動作を記述
    }
  }, function () {
    if (responsibleCheck == '1') {
      $(this).find('dd').stop().slideToggle();
      //ここにはマウスを離したときの動作を記述
    }

  });


  let topicsCategoryList = $('.topicsCategoryList .activeSp');
  topicsCategoryList.on('click', function () {
    $(this).stop().toggleClass('categoryOpen');
    $(this).next().stop().slideToggle(500);
  });

  topicsCategoryList.on({
    'mouseover': function () {
      if (responsibleCheck == '1') {
        topicsFlg = 1;
        $(this).toggleClass('categoryOpen');
        $(this).next().stop().slideToggle(500);
      }
    }
  });
  
  let pageNateItemCount = $('ul.custom li.page').length;
  let pageNateItem = $('ul.custom li.page');
  if(pageNateItemCount > 4){
    let pageNateNum = $('ul.custom li.page.active').find('a').text() - 1;
    let pageNateAllNum = pageNateItemCount - 1;
    
    if(pageNateNum == 0){
        pageNateItem.slice(4, pageNateItemCount).css('display', 'none');
    } else if(pageNateNum == 1){
        pageNateItem.slice(4, pageNateItemCount).css('display', 'none');
    } else if(pageNateNum == 2){
        pageNateItem.slice(0, pageNateNum - 1).css('display', 'none');
        pageNateItem.slice(pageNateNum + 3, pageNateItemCount).css('display', 'none');
    } else if(pageNateNum == pageNateAllNum){
        pageNateItem.slice(0, pageNateNum - 3).css('display', 'none');
    } else if(pageNateNum == pageNateAllNum - 1){
       pageNateItem.slice(0, pageNateNum - 2).css('display', 'none');
       pageNateItem.slice(pageNateNum + 3, pageNateItemCount).css('display', 'none');
    } else {
       pageNateItem.slice(0, pageNateNum - 1).css('display', 'none');
       pageNateItem.slice(pageNateNum + 3, pageNateItemCount).css('display', 'none');
    }
    
  }
}
